import React from 'react';
import { useIntegrationContext } from '../IntegrationProvider';
import Grid from '@material-ui/core/Grid';
import IntegrationApp from './IntegrationApp';
import IntegrationConfiguration from './IntegrationConfiguration';
import IntegrationInformation from './IntegrationInformation';
import IntegrationParameters from './IntegrationParameters';

const IntegrationDetails = () => {
  const { integration } = useIntegrationContext();
  const hasConfiguration = Object.keys(integration?.configuration ?? {}).length > 0;
  const hasParameters = Object.keys(integration?.parameters ?? {}).length > 0;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={6} xl={6}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <IntegrationInformation />
          </Grid>
          {hasConfiguration && (
            <Grid item xs={12}>
              <IntegrationConfiguration />
            </Grid>
          )}
          {hasParameters && (
            <Grid item xs={12}>
              <IntegrationParameters />
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12} lg={6} xl={6}>
        <IntegrationApp />
      </Grid>
    </Grid>
  );
};

export default IntegrationDetails;
